import styled, { createGlobalStyle, css } from 'styled-components';

const GlobalNavStyles = createGlobalStyle `
    .helix-unified-nav__dropdown-menu {
        z-index: 1051;
    }
`;
const colors = {
    gray: {
        50: '#f9fafb',
        100: '#f3f4f6',
        200: '#e5e7eb',
        300: '#d1d5db',
        400: '#9ca3af',
        500: '#6b7280',
        600: '#4b5563',
        700: '#374151',
        800: '#1f2937',
        900: ' #111827'
    }
};
const StyledNavbar = styled.header `
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans',
        'Helvetica Neue', sans-serif;
    padding: ${({ $hasExpandIcon, $reducePaddingLeft }) => $hasExpandIcon ? '10px 32px 10px 12px' : $reducePaddingLeft ? '10px 32px 10px 14px' : '10px 32px'};

    font-size: 14px;
    background-color: ${({ $isDark }) => ($isDark ? '#111827' : 'rgba(255, 255, 255, 0.8)')};
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(48px);
    box-sizing: border-box;
    display: flex;
    color: ${({ $isDark }) => ($isDark ? '#F9FAFB' : '#111827')};
    align-items: center;
    z-index: 1050;
    position: relative;
    height: ${({ $variant }) => ($variant === 'small' ? '48px' : '60px')};
    ${({ $fixed }) => $fixed &&
    css `
            position: fixed;
            left: 0;
            right: 0;
            top: 0;
        `}
    .helix-unified-navbar__logo-wrapper {
        flex: 0;
        width: fit-content;
        display: flex;
        align-items: center;
        &.helix-unified-navbar__logo-wrapper-with-body {
            flex: 0;
        }
        .helix-unified-navbar__logo {
            height: 32px;
            a {
                &:focus {
                    outline: solid 2px ${colors.gray[300]};
                    border-radius: 4px;
                }
            }
        }
        .helix-unified-navbar__application-name {
            white-space: nowrap;
            margin: 0 12px;
            font-weight: 600;
            -webkit-font-smoothing: antialiased;
        }
    }

    .helix-unified-nav__navigation-item {
        display: inline-flex;
        flex: 0 0 auto;
        align-items: center;
        border: none;
        padding: 8px 12px;
        border-radius: 6px;
        background-color: transparent;
        color: ${({ $isDark }) => ($isDark ? '#F9FAFB' : ' #4B5563')};
        font-weight: 600;
        font-size: inherit;
        text-decoration: none;
        -webkit-font-smoothing: antialiased;
        cursor: pointer;
        &:hover {
            color: ${({ $isDark }) => ($isDark ? '#F9FAFB' : '#374151')};
            background-color: ${({ $isDark }) => ($isDark ? '#1F2937' : '#F3F4F6')};
        }
        &.active {
            color: ${({ $isDark }) => ($isDark ? '#fff' : '#111827')};
            background-color: ${({ $isDark }) => ($isDark ? '#374151' : '#E5E7EB')};
        }
        &:focus {
            outline: solid 2px ${colors.gray[300]};
            box-sizing: border-box;
        }
        &[disabled],
        &.disabled {
            opacity: 0.5;
            cursor: pointer;
            pointer-events: none;
        }
        &.helix-unified-nav__navigation-item_more {
            i.material-icons {
                font-size: 20px;
            }
        }
    }

    .helix-unified-nav__mobile-menu-trigger,
    .helix-unified-nav__mobile-notification-trigger {
        padding: 8px;
        ${({ $isDark }) => $isDark &&
    css `
                svg path:not(.alert-dot) {
                    fill: currentColor !important;
                }
            `}
    }

    .helix-unified-nav__mobile-menu-trigger {
    }

    @media screen and (max-width: 576px) {
        padding: 12px;
    }

    .alert-dot {
        fill: ${({ $isDark }) => ($isDark ? '#F87171' : '#DC2626')}!important;
    }

    a.helix-unified-nav__nav-button-link,
    button.helix-unified-nav__nav-button {
        display: inline-flex;
        flex: 0 0 auto;
        align-items: center;
        border: none;
        padding: 8px;
        border-radius: 6px;
        background-color: transparent;
        color: inherit;
        &.helix-unified-nav__nav-button-drawer {
            margin-right: 8px;
            ${({ $isDark }) => $isDark &&
    css `
                    svg path:not(.alert-dot) {
                        fill: currentColor !important;
                    }
                `}
        }
        &.helix-unified-nav__nav-button-user {
            padding: 0;
            margin-left: 8px;
            border-radius: 50%;
            .helix-unified-nav__user-avatar {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                overflow: hidden;
                display: flex;
                align-items: center;
                object-position: center center;
                img {
                    width: 32px;
                    height: 32px;
                    object-fit: cover;
                }
            }
            &.active {
                border: solid 2px ${({ $isDark }) => ($isDark ? '#374151' : '#D1D5DB')};
            }
        }
        &:focus {
            outline: solid 2px #60a5fa;
        }

        &.active:not(.helix-unified-nav__nav-button-user) {
            background-color: ${({ $isDark }) => ($isDark ? '#374151' : '#E5E7EB')};
        }
        &:hover:not(.helix-unified-nav__nav-button-user) {
            background-color: ${({ $isDark }) => ($isDark ? '#374151' : '#F3F4F6')};
        }
        &:hover {
            text-decoration: none;
        }
        &.primary-text-color {
            color: #2563eb;
        }
        &.unified-nav__nav-icon-action {
            white-space: nowrap;
            font-weight: 600;
            svg {
                margin-right: 8px;
            }
        }
    }
    ${({ $reducePaddingLeft }) => $reducePaddingLeft &&
    css `
            .helix-unified-navbar__body {
                flex: unset;
            }
        `}

    // added the following styles to support helix 2 type styles in the navbar

.helix-display-x-large {
        font-size: 48px;
        font-weight: 600;
        line-height: 52px;
        @media screen and (max-width: 768px) {
            font-size: 32px;
            line-height: 35px;
        }
    }

    .helix-display-large {
        font-size: 36px;
        font-weight: 600;
        line-height: 44px;
        @media screen and (max-width: 768px) {
            font-size: 24px;
            line-height: 29px;
        }
    }

    .helix-display-medium {
        font-size: 30px;
        font-weight: 600;
        line-height: 36px;
        @media screen and (max-width: 768px) {
            font-size: 20px;
            line-height: 24px;
        }
    }

    .helix-display-small {
        font-size: 24px;
        font-weight: 600;
        line-height: 30px;
        @media screen and (max-width: 768px) {
            font-size: 16px;
            line-height: 20px;
        }
    }

    .helix-display-x-small {
        font-size: 20px;
        font-weight: 600;
        line-height: 26px;
        @media screen and (max-width: 768px) {
            font-size: 15px;
            line-height: 18px;
        }
    }

    .helix-heading {
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        @media screen and (max-width: 768px) {
            font-size: 17px;
            line-height: 24px;
        }
    }

    .helix-subheading {
        font-size: 12px;
        font-weight: 600;
        line-height: 20px;
        @media screen and (max-width: 768px) {
            font-size: 13px;
            line-height: 17px;
        }
    }

    .helix-body {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        @media screen and (max-width: 768px) {
            font-size: 15px;
            line-height: 20px;
        }
    }

    .helix-body--strong {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        @media screen and (max-width: 768px) {
            font-size: 15px;
            line-height: 20px;
        }
    }

    .helix-number {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        font-feature-settings: 'tnum' on, 'lnum' on;
        @media screen and (max-width: 768px) {
            font-size: 15px;
            line-height: 20px;
        }
    }

    .helix-number--strong {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        font-feature-settings: 'tnum' on, 'lnum' on;
        @media screen and (max-width: 768px) {
            font-size: 15px;
            line-height: 20px;
        }
    }

    .helix-small {
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        @media screen and (max-width: 768px) {
            font-size: 13px;
            line-height: 17px;
        }
    }

    .helix-small--strong {
        font-size: 12px;
        font-weight: 600;
        line-height: 16px;
        @media screen and (max-width: 768px) {
            font-size: 13px;
            line-height: 17px;
        }
    }

    // get each of the gray colors from the theme and create a class for each

    .helix-text-gray-50 {
        color: ${colors.gray[50]};
    }

    .helix-text-gray-100 {
        color: ${colors.gray[100]};
    }

    .helix-text-gray-200 {
        color: ${colors.gray[200]};
    }

    .helix-text-gray-300 {
        color: ${colors.gray[300]};
    }

    .helix-text-gray-400 {
        color: ${colors.gray[400]};
    }

    .helix-text-gray-500 {
        color: ${colors.gray[500]};
    }

    .helix-text-gray-600 {
        color: ${colors.gray[600]};
    }

    .helix-text-gray-700 {
        color: ${colors.gray[700]};
    }

    .helix-text-gray-800 {
        color: ${colors.gray[800]};
    }

    .helix-text-gray-900 {
        color: ${colors.gray[900]};
    }
`;
const StyledNavbarNav = styled.nav `
    display: flex;
    overflow: hidden;
    white-space: nowrap;
    flex: 1 1 auto;
    justify-content: center;
    padding: 3px 0px;
    margin: 0 auto;
    .helix-unified-nav__navigation-items-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    a.helix-unified-nav__navigation-item {
        text-decoration: none;
    }
    .helix-unified-nav__navigation-item,
    .helix-unified-nav__navigation-item-dropdown-wrapper {
        + .helix-unified-nav__navigation-item,
        + .helix-unified-nav__overflow-button-wrapper,
        + .helix-unified-nav__navigation-item-dropdown-wrapper {
            margin-left: 12px;
        }
        @media screen and (max-width: 576px) {
            padding: 4px 6px;
            + .helix-unified-nav__navigation-item,
            + .helix-unified-nav__overflow-button-wrapper {
                margin-left: 4px;
            }
        }
    }
    .helix-unified-nav__overflow-button-wrapper,
    .helix-unified-nav__navigation-item-dropdown {
        svg {
            margin-left: 8px;
            margin-top: 2px;
            color: inherit;
            path {
                fill: currentColor !important;
            }
        }
    }
    .helix-unified-nav__overflow-button-wrapper {
        display: ${({ $hasOverflowItems }) => ($hasOverflowItems ? 'flex' : 'none')};
    }
    ul.menu-item-list {
        margin: 0 auto;
        padding: 0;
        list-style: none;
        display: flex;
        justify-content: center;

        li {
            padding: 8px 12px;
            border-radius: 6px;
            &:hover,
            &.active {
                background-color: #f3f4f6;
            }
            &:focus {
                outline: solid 2px ${colors.gray[300]};
            }
            + li {
                margin-left: 8px;
            }
        }
    }

    @media screen and (max-width: 576px) {
        visibility: hidden;
    }
`;
const StyledNavbarBody = styled.div `
    flex: 1 1;
`;
const StyledNavbarAdditionalItems = styled.div `
    margin-left: 12px;
    display: flex;
    flex: 0;
    justify-content: flex-end;
    ${({ $hasNavItems }) => !$hasNavItems &&
    css `
            justify-content: flex-end;
            align-items: center;
            flex: 1 1;
        `}
    a {
        text-decoration: none;
    }
    .helix-unified-nav__additional-nav-item {
        display: flex;
        align-items: center;
        border-radius: 6px;
        &.active:not(.helix-unified-nav__additional-user-menu-toggle) {
            background-color: ${({ $isDark }) => ($isDark ? '#374151' : '#E5E7EB')};
        }
        &:hover:not(.helix-unified-nav__additional-user-menu-toggle) {
            background-color: ${({ $isDark }) => ($isDark ? '#374151' : '#F3F4F6')};
        }
        &:focus {
            outline: solid 2px ${colors.gray[300]};
        }
        i {
            font-size: 24px;
        }
    }

    a.helix-unified-nav__nav-button-link,
    button.helix-unified-nav__nav-button {
        display: inline-flex;
        flex: 0 0 auto;
        align-items: center;
        border: none;
        padding: 8px;
        border-radius: 6px;
        background-color: transparent;
        color: inherit;
        &.helix-unified-nav__nav-button-drawer {
            margin-right: 8px;
            ${({ $isDark }) => $isDark &&
    css `
                    svg path:not(.alert-dot) {
                        fill: currentColor !important;
                    }
                `}
        }
        &.helix-unified-nav__nav-button-user {
            padding: 0;
            margin-left: 8px;
            border-radius: 50%;
            .helix-unified-nav__user-avatar {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                overflow: hidden;
                display: flex;
                align-items: center;
                object-position: center center;
                img {
                    width: 32px;
                    height: 32px;
                    object-fit: cover;
                }
            }
            &.active {
                border: solid 2px ${({ $isDark }) => ($isDark ? '#374151' : '#D1D5DB')};
            }
        }
        &:focus {
            outline: solid 2px ${colors.gray[300]};
        }

        &.active:not(.helix-unified-nav__nav-button-user) {
            background-color: ${({ $isDark }) => ($isDark ? '#374151' : '#E5E7EB')};
        }
        &:hover:not(.helix-unified-nav__nav-button-user) {
            background-color: ${({ $isDark }) => ($isDark ? '#374151' : '#F3F4F6')};
        }

    ${({ $isDark }) => $isDark &&
    css `
            svg.helix-icon path:not(.alert-dot) {
                fill: currentColor !important;
            }
        `}

    @media screen and (max-width: 576px) {
        display: none;
    }
`;
const StyledUserMenu = styled.div `
    svg.helix-icon path:not(.alert-dot) {
        fill: currentColor !important;
    }
`;
const StyledNotificationMenu = styled.div ``;
const StyledMobileMenu = styled.div `
    margin-left: 12px;
    .helix-unified-nav__navigation-item + .helix-unified-nav__navigation-item {
        margin-left: 12px;
    }
    @media screen and (max-width: 576px) {
        justify-content: flex-end;
        display: flex;
        ${({ $hasNavItems }) => !$hasNavItems &&
    css `
                flex: 1 1;
            `}
    }
`;
const StyledMobileMenuPanel = styled.div `
    position: fixed;
    height: calc(100vh - 60px);
    left: 0;
    top: 60px;
    right: 0;
    bottom: 0;
    background-color: #fff;
    padding: 8px;
    box-sizing: border-box;
    border-top: 1px solid #e5e7eb;
    overflow: auto;
    .helix-unified-navbar__panel-header {
        font-size: 20px;
        line-height: 26px;
        font-weight: 600;
        margin: 16px 8px;
        display: block;
        color: #111827;
    }
    .helix-unified-navbar__mobile-menu-profile-item {
        padding: 8px;
        display: flex;
        .helix-unified-nav__user-avatar {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            overflow: hidden;
            display: flex;
            align-items: center;
            object-position: center center;
            img {
                width: 32px;
                height: 32px;
                object-fit: cover;
            }
        }
        .helix-unified-navbar__mobile-menu-user-info {
            display: flex;
            flex-flow: column;
            margin-left: 12px;
            color: #111827;
            .helix-unified-navbar__mobile-menu-user-info-name {
                font-weight: 600;
            }
        }
    }

    .helix-unified-navbar__mobile-menu-header {
        display: flex;
        font-weight: 600;
        padding: 8px;
        align-items: center;
        text-transform: uppercase;
        font-size: 12px;
        color: #111827;
    }
    .helix-unified-navbar__mobile-menu-item {
        display: flex;
        margin-bottom: 2px;
        border-radius: 4px;
        &.helix-unified-navbar__mobile-menu-help-item {
            svg {
                margin-right: 8px;
            }
        }
        &.disabled {
            opacity: 0.5;
            pointer-events: none;
            cursor: default;
        }
        &:focus-within {
            outline: solid 2px ${colors.gray[300]};
        }
        &:focus-within,
        &:hover {
            color: #374151;
            background-color: #f3f4f6;
            text-decoration: none;
        }
        &.active {
            color: #111827;
            background-color: #e5e7eb;
        }

        .helix-unified-nav__mobile-menu-dropdown-button,
        a,
        .helix-unified-navbar__mobile-menu-notification-item {
            width: 100%;
            display: flex;
            align-items: center;
            font-size: inherit;
            text-decoration: none;
            color: #111827;
            font-weight: 400;
            -webkit-font-smoothing: antialiased;
            border-radius: 4px;
            padding: 8px;
            &.helix-unified-navbar__mobile-menu-notification-item {
                font-weight: normal;
            }
            &.helix-unified-nav__mobile-menu-dropdown-toggle {
                display: flex;
                .helix-unified-nav__mobile-menu-label {
                    flex: 1 1;
                    text-align: left;
                }
            }
            &:focus {
                outline: none;
            }
            &.helix-unified-nav__mobile-menu-dropdown--with-badge {
                justify-content: space-between;
            }
            a {
                padding: 0;
            }
            &.active {
                color: #111827;
                background-color: #e5e7eb;
            }
        }
        button {
            background-color: transparent;
            border: none;
            &:focus {
                color: #374151;
                text-decoration: none;
            }
            &:focus {
                outline: none;
            }
            &.helix-unified-navbar__mobile-menu-item-dropdown {
                svg {
                    margin-left: 8px;
                }
            }
        }
        &.helix-unified-navbar__mobile-sub-menu-item {
            margin-left: 12px;
        }
        .helix-unified-navbar__mobile-menu-divider {
            border-top: 1px solid #e5e7eb;
            margin: 8px 0;
        }
    }
    .empty-state {
        padding: 8px;
        text-align: center;
    }
    .helix-unified-navbar__mobile-menu-notification-item {
        margin: 2px 0;
    }
    hr {
        border-top: 1px solid #e5e7eb;
        margin: 1rem 0;
    }
`;
const StyledCustomDropdownSection = styled.div `
    padding-left: 12px;
`;

export { GlobalNavStyles, StyledCustomDropdownSection, StyledMobileMenu, StyledMobileMenuPanel, StyledNavbar, StyledNavbarAdditionalItems, StyledNavbarBody, StyledNavbarNav, StyledNotificationMenu, StyledUserMenu };
//# sourceMappingURL=Navbar.styles.js.map
